<ngb-alert 
  *ngIf="form.invalid && (form.dirty || form.touched)" 
  type="danger">
  <button type="button" class="btn-close" (click)="closeAlert()" aria-label="Close"></button>
  <ul>
    <li *ngFor="let control of controls">
      <div *ngIf="shouldShowErrors(control)">
        <ul>
          <li *ngIf="control.errors?.required">
            <strong>{{ controlName(control) }} {{ 'is required' | translate }}.</strong>
          </li>
          <li *ngIf="control.errors?.minlength">
            <strong>{{ controlName(control) }} {{ 'must be at least' | translate }} {{ control.errors.minlength.requiredLength }} {{ 'characters long' | translate }}.</strong>
          </li>
          <li *ngIf="control.errors?.maxlength">
            <strong>{{ controlName(control) }} {{ 'can be no more than' | translate }} {{ control.errors.maxlength.requiredLength }} characters long.</strong>
          </li>
          <li *ngIf="control.errors?.pattern">
            <strong>{{ controlName(control) }} {{ 'has an invalid format' | translate }}.</strong>
          </li>
          <li *ngIf="control.errors?.email">
            <strong>{{ controlName(control) }} {{ 'must be a valid email address' | translate }}.</strong>
          </li>
          <li *ngIf="control.errors?.min">
            <strong>{{ controlName(control) }} {{ 'must be at least' | translate }} {{ control.errors.min.min }}.</strong>
          </li>
          <li *ngIf="control.errors?.max">
            <strong>{{ controlName(control) }} {{ 'can be no more than' | translate }} {{ control.errors.max.max }}.</strong>
          </li>
          <!-- Add more specific validation messages here -->
        </ul>
      </div>
    </li>
  </ul>
</ngb-alert>
